import { graphql, useStaticQuery } from 'gatsby';
import { FileNode } from 'gatsby-plugin-image/dist/src/components/hooks';
import { CatalogCardProps } from './catalogQuery';
const featuredCatalogQuery = () => {
  const data = useStaticQuery(graphql`
    query FeaturedCatalogQuery {
      featuredCatalog: allMdx(
        sort: { frontmatter: { date: ASC } }
        filter: {
          frontmatter: {
            category: { eq: "catalog" }
            published: { eq: true }
            featured: { eq: true }
          }
        }
        limit: 3
      ) {
        featuredCatalogItems: nodes {
          id
          frontmatter {
            title
            date(formatString: "MMM Do, YYYY")
            code
            slug
            published
            featured
            category
            tags
            badge
            description
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 400)
              }
            }
            embeddedImagesLocal {
              childImageSharp {
                gatsbyImageData(width: 400)
              }
            }
          }
        }
      }
    }
  `);

  // const featuredCatalogItems:CatalogCardProps[] = data.catalog.featuredCatalogItems;
  const featuredCatalogItems: CatalogCardProps[] =
    data.featuredCatalog.featuredCatalogItems;
  return { featuredCatalogItems };
};

export { featuredCatalogQuery };
